import { sleep } from '@japan-culture-and-technology/calchez-utils/src/sleep';

import { useToastKey } from '@/injectionKeys';
import { TOAST, stateFactory } from '@/utils/state';
export type ToastType = 'SUCCESS' | 'WARNING' | 'ERROR';

export interface ToastState {
  shouldShowToast: boolean;
  type: ToastType;
  message: string;
  multiline: boolean;
}

const CreateDefaultToast = (): ToastState => ({
  shouldShowToast: false,
  type: 'SUCCESS',
  message: '',
  multiline: false,
});

export interface ShowToastArgs {
  message: string;
  type: ToastType;
  multiline?: boolean;
  duration?: number;
}

/**
 * 画面側でグローバル State を更新すれば自動で Toast が表示される仕組み
 * showToast 関数を呼ぶと、デフォルトで3秒後に Toast が消える
 * multiline オプションで改行対応、duration オプションで表示時間をカスタマイズ可能
 */
export const useBaseToast = () => {
  const toast = stateFactory.create<ToastState>(TOAST, CreateDefaultToast());

  const showToast = async ({ message, type, multiline = false, duration = 3000 }: ShowToastArgs) => {
    await sleep(100);

    toast.value.shouldShowToast = true;
    toast.value.message = message;
    toast.value.type = type;
    toast.value.multiline = multiline;

    await sleep(duration);

    toast.value.shouldShowToast = false;
    toast.value.message = '';
    toast.value.multiline = false;
  };

  return { toast, showToast };
};

export const useToast = () => {
  const injectedUseToast = inject(useToastKey) as typeof useBaseToast;
  return injectedUseToast();
};
